import React from "react";
import { Users, ExternalLink } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const AdminsManager = () => {
  const { admin } = useAuth();

  return (
    <div className="max-w-2xl" data-testid="admins-page">
      <h1 className="font-serif text-3xl text-ink mb-1">Admins</h1>
      <p className="text-sm text-ink-muted mb-6">People who can edit the website and blog.</p>

      <div className="rounded-xl border border-cream-2 bg-white p-6 mb-6" data-testid="current-admin">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-sage/15 flex items-center justify-center">
            <Users className="h-5 w-5 text-sage-dark" />
          </div>
          <div>
            <p className="font-medium text-ink">Signed in as</p>
            <p className="text-sm text-ink-muted">{admin?.email}</p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-cream-2 bg-cream/40 p-6">
        <h2 className="font-serif text-xl text-ink mb-2">Add or remove admins</h2>
        <p className="text-sm text-ink-soft leading-relaxed">
          Admin accounts are managed securely in your Supabase project. To add a new admin, open
          your Supabase dashboard → <span className="font-medium">Authentication → Users → Add user</span>,
          enter their email and a password, and enable “Auto Confirm User”. They can then sign in here.
        </p>
        <a
          href="https://supabase.com/dashboard"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="open-supabase-link"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-sage text-white px-5 py-2.5 text-sm font-semibold hover:bg-sage-dark transition-colors"
        >
          Open Supabase dashboard <ExternalLink className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default AdminsManager;
